import { getCurrentStateChainConfig } from 'config/configUtils';
import { capitalizeFirstLetter } from 'lib/string';
import { getActiveChainFromState } from 'reduxState/exchange/exchangeActiveChain';

/**
 * ETH errors https://github.com/MetaMask/eth-rpc-errors/blob/main/src/error-constants.ts
 * Also used by providers like Metamask
 *  https://ethereum.stackexchange.com/questions/101999/is-there-an-official-comprehensive-list-of-metamask-rpc-error-codes
 */
export const ETH_USER_REJECTED_REQUEST_ERROR_CODE = 4001;

// export class Web3UserRejectedError extends Error {
//   public code = ETH_USER_REJECTED_REQUEST_ERROR_CODE;
// }

export const REJECT_WALLET_PROMPT_ERROR = 'User rejected the request.';

export const INSUFFICIENT_STARGATE_LIQUIDITY =
  'Insufficient liquidity in Stargate bridge. Enter a smaller amount or contact support for options.';

interface EthersError extends Error {
  // Ethers adds more information for us
  error?: Error;
  reason?: string;
  data?: {
    message?: string;
  };
  body?: {
    error?: {
      message?: string;
    };
  };
}

const isNotEnoughEthForGasError = (error: EthersError): boolean => {
  return [
    // Ethers.js - RPC
    'gas required exceeds',
    'insufficient funds for gas',
  ].some(
    message =>
      `${error?.message}`.toLowerCase().includes(message) ||
      `${error?.error?.message}`.toLowerCase().includes(message)
  );
};

// TODO: stargate - Should not be needed anymore
// const isStargateFeeLibraryNotEnoughLiquidityError = (
//   error: EthersError
// ): boolean => {
//   const findMessage = 'FeeLibrary: not enough balance'.toLowerCase();
//   console.log({ error, reason: error?.reason });
//   return (
//     `${error?.reason}`.toLowerCase().includes(findMessage) ||
//     `${error?.message}`.toLowerCase().includes(findMessage) ||
//     `${error?.error?.message}`.toLowerCase().includes(findMessage)
//   );
// };

/**
 * Format ethers error object to human redable error
 * If normal error provided, display it's error.message
 */
export const makeEthersErrorHumanRedable = (error: EthersError): string => {
  if (isNotEnoughEthForGasError(error)) {
    const chain = getActiveChainFromState();
    const { chainCurrency } = getCurrentStateChainConfig(chain);
    return `Not enough ${chainCurrency} to cover gas fees or transaction failure.`;
  }

  // if (isStargateFeeLibraryNotEnoughLiquidityError(error)) {
  //   return INSUFFICIENT_STARGATE_LIQUIDITY;
  // }

  if (error?.toString().includes('-32002')) {
    // Repro: Metamask with already pending Modal error (ignored) - ugly "Could not coalesce error"
    return 'You already have a pending request in your wallet. Please review any outstanding wallet pop-ups or requests before trying again.';
  }

  // For ethers error.message contains data formatted very ugly
  if (error?.reason) {
    const subMessage = error?.error?.message || error?.body?.error?.message;
    return capitalizeFirstLetter(
      error.reason + (subMessage ? ` - ${subMessage}` : '')
    );
  }
  if (error?.message === 'Internal JSON-RPC error.') {
    // Data contain more meaningful message
    return capitalizeFirstLetter(
      error?.data?.message ||
        error?.error?.message ||
        (error as any)?.shortMessage ||
        error?.message ||
        ''
    );
  }
  // In case of standard errors, display just message
  return capitalizeFirstLetter(
    error?.error?.message ||
      (error as any)?.shortMessage ||
      error?.message ||
      ''
  );
};
